module.exports = __webpack_public_path__ + "static/media/xls.21969610.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/assets/file icons/xls.svg
// module id = 274
// module chunks = 0